export const categories = (self) => {
    return [
        { label: self.$t('All'), value: 0 },
        { label: self.$t('Exchange/External'), value: 1 },
        { label: self.$t('IB Operations'), value: 2 },
        { label: self.$t('Marketing/Education'), value: 3 },
        { label: self.$t('Corporate Actions'), value: 5 },
        { label: self.$t('Other'), value: 6 }
    ];
}
